// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__learning-unit-members[data-v-17dfcf18]{min-width:300px}", ""]);
// Exports
module.exports = exports;
